/** Sinf nomlarini birlashtiradi; `false | null | undefined` tashlanadi. */
export const cn = (...classes) => classes.filter((c) => typeof c === 'string' && c.length > 0).join(' ');
//# sourceMappingURL=cn.js.map